
import React, { useEffect, useRef, useState } from "react";

import aboutbanner from "../../assets/images/aboutbanner.jpg";

import "./TermsAndCondition.scss";
import { Link } from "react-router-dom";
import { getTnCApi } from "../../services/supplierService";
import Api from "../../api";

function TermsAndCondition() {

    const [tncData,setTncData] = useState()

    const tncCall = () =>{
        getTnCApi().then((res)=>{
          if(res.status === "success"){
            setTncData(res.data);
            console.log(res.data)
          }
        })
      }
    
      useEffect(()=>{
        tncCall()
      },[])
  return (
    <div className="tncpage" >
      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-12 px-0 banner-img"
            style={{
              backgroundImage: tncData? `url(${tncData?.section_1_image})`  : `url(${aboutbanner})`,
            }}
          >
            <div className="container">
              <div className="row ">
                <div className="pagename px-0">
                  <h1>{tncData? tncData?.section_1_heading : "Terms and Conditions"}</h1>
                  <Link to="/">{tncData?.section_1_button_text ? tncData?.section_1_button_text : "Back to Home"}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tncContent">
        <div className="container">
            <h3>{tncData? tncData?.section_1_heading : "Terms and Conditions"}</h3>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-12 px-lg-0 ">
              <p>
                <div dangerouslySetInnerHTML= {{__html: tncData?.section_2_description}}></div>
                {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Ultrices in tellus vitae proin. Adipiscing amet, iaculis
                tincidunt aliquam in. Nec nunc neque orci viverra proin tellus
                justo. Rhoncus, iaculis nisl, turpis quis.Lorem ipsum dolor sit
                amet, consectetur adipiscing elit. Ultrices in tellus vitae
                proin. Adipiscing amet, iaculis tincidunt aliquam in. Nec nunc
                neque orci viverra proin tellus justo. Rhoncus, iaculis nisl,
                turpis quis.Lorem ipsum dolor sit amet, consectetur adipiscing
                elit. Ultrices in tellus vitae proin. Adipiscing amet, iaculis
                tincidunt aliquam in. Nec nunc neque orci viverra proin tellus
                justo. Rhoncus, iaculis nisl, turpis quis.Lorem ipsum dolor sit
                amet, consectetur adipiscing elit. Ultrices in tellus vitae
                proin. Adipiscing amet, iaculis tincidunt aliquam in. Nec nunc
                neque orci viverra proin tellus justo. Rhoncus, iaculis nisl,
                turpis quis.Lorem ipsum dolor sit amet, consectetur adipiscing
                elit. Ultrices in tellus vitae proin. Adipiscing amet, iaculis
                tincidunt aliquam in. Nec nunc neque orci viverra proin tellus
                justo. Rhoncus, iaculis nisl, turpis quis. */}
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsAndCondition